import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { TokenClient } from './token-client';

@Injectable({
    providedIn: 'root'
})
export class ApiClient extends TokenClient {
    constructor(
        http: HttpClient,
    ) {
        super(http);
    }
}
